import { useTheme } from "styled-components";

import StarRatingPartially from "@/main/components/shared/starRating/starRatingPartially";
import TooltipComponent from "@/main/components/shared/tooltip/tooltipComponent";

import { EvaluationPartialScoreData } from "@/main/models/response";
import { getTranslateByKey, isNullUndefined } from "@/main/services/utils";

import * as SShared from "@/main/components/shared/styles";
import * as S from "./styles";

interface IRowEvaluationProps {
	titleTooltip: string;
	title: string;
}
function RowEvaluation({ titleTooltip, title }: IRowEvaluationProps) {
	const theme = useTheme();

	return (
		<TooltipComponent
			title={<S.TitleTooltip>{titleTooltip}</S.TitleTooltip>}
			placement="top-start"
			maxWidth="800px"
			backgroundColor={theme.grayDark}
		>
			<S.TitleEvaluation>{title}</S.TitleEvaluation>
		</TooltipComponent>
	);
}
interface IScoreInfoProps {
	dataScoreInfo: EvaluationPartialScoreData | null;
}
function ScoreInfo({ dataScoreInfo }: IScoreInfoProps) {
	if (isNullUndefined(dataScoreInfo)) return <></>;

	const messageTooltipSpeedToQuote = getTranslateByKey("information.speedQuoteEvaluationTooltip");
	const messageTooltipDeliveryAccuracy = getTranslateByKey("information.deliveryAccuracyEvaluationTooltip");

	const messageTooltipWithoutManualEvaluation = getTranslateByKey("information.manualEvaluationTooltipWithEvaluation");
	const messageTooltipWithManualEvaluation = getTranslateByKey(
		"information.manualEvaluationTooltipWithoutEvaluation",
	).replace("{0}", String(dataScoreInfo.totalEvaluationsConsidered));
	const messageTooltipManualEvaluation =
		dataScoreInfo.totalEvaluationsConsidered === 0
			? messageTooltipWithoutManualEvaluation
			: messageTooltipWithManualEvaluation;

	return (
		<S.Container id="id-register-scoreInfo">
			<SShared.HeaderText>{getTranslateByKey("information.scoreInfo")}</SShared.HeaderText>
			<S.AreaEvaluation>
				<S.AreaRowEvaluation>
					<RowEvaluation
						title={`${getTranslateByKey("information.speedToQuote")} - ${dataScoreInfo.speedToQuoteScore} ${getTranslateByKey("information.stars")}`}
						titleTooltip={messageTooltipSpeedToQuote}
					/>
					<StarRatingPartially rating={dataScoreInfo.speedToQuoteScore} />
				</S.AreaRowEvaluation>
				<S.AreaRowEvaluation>
					<RowEvaluation
						title={`${getTranslateByKey("information.deliveryAccuracy")} - ${dataScoreInfo.deliveryAccuracyScore} ${getTranslateByKey("information.stars")}`}
						titleTooltip={messageTooltipDeliveryAccuracy}
					/>
					<StarRatingPartially rating={dataScoreInfo.deliveryAccuracyScore} />
				</S.AreaRowEvaluation>
				<S.AreaRowEvaluation>
					<RowEvaluation
						title={`${getTranslateByKey("information.manualEvaluation")} - ${dataScoreInfo.manualEvaluationScore} ${getTranslateByKey("information.stars")}`}
						titleTooltip={messageTooltipManualEvaluation}
					/>
					<StarRatingPartially rating={dataScoreInfo.manualEvaluationScore} />
				</S.AreaRowEvaluation>
			</S.AreaEvaluation>
			<S.AreaScoreAverage>
				<S.TitleScoreAverage>{getTranslateByKey("information.scoreAverage")}</S.TitleScoreAverage>
				<S.ScoreAverage>
					<StarRatingPartially rating={dataScoreInfo.totalScore} />
					<p>
						{dataScoreInfo.totalScore} {getTranslateByKey("information.stars")}
					</p>
				</S.ScoreAverage>
			</S.AreaScoreAverage>
		</S.Container>
	);
}

export default ScoreInfo;
